import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgSelectModule } from '@ng-select/ng-select';
import moment from 'moment';
import { ModelService } from '../../../../core/services/model/model.service';
import { AlertService } from '../../../../core/services/alert/alert.service';
import { OrdersService } from '../../../../core/services/orders/orders.service';
import { Router, RouterModule } from '@angular/router';
import { CampaignStockVin } from '../../../../core/interfaces/campaign-stock-vins';
import { VinSelectorComponent } from './vin-selector/vin-selector.component';
import { copyToClipboard as copyToClipboardUtil } from '../../../../core/utils/clipboard.utils';


@Component({
  selector: 'app-vehicle-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    RouterModule,
    CommonModule,
    NgSelectModule,
    VinSelectorComponent],
  templateUrl: './vehicle-form.component.html',
  styleUrl: './vehicle-form.component.css'
})
export class VehicleFormComponent {
  @Input() orderData?: any;
  @Input() ladata: any = [];
  @Output() emitDuplicate = new EventEmitter<boolean>();
  @Output() dealershipFromVin = new EventEmitter<string>();
  @Output() emitChangeBrand = new EventEmitter<string>();

  vehicleForm: FormGroup;
  models: any[] = [];
  brands: any[] = [];

  vehicleStatusOptions: { key: string; name: string }[] = [
    { key: 'new', name: 'new' },
    { key: 'used', name: 'used' },
  ];

  vehicle_model_id_ = '';
  showAlertLicensePlate = false;
  urlLicensePlate = '';
  showAlertVin = false;
  urlVin = '';
  dealershipData: any = [];
  showVinSelector = false;
  availableVins: CampaignStockVin[] = [];
  constructor(private fb: FormBuilder, private modelService: ModelService, private alertService: AlertService, private orderService: OrdersService,private router: Router) {
    this.vehicleForm = this.fb.group({
      colour: ['', Validators.required],
      vehicle: ['', Validators.required],
      vehicle_brand_id: ['', Validators.required],
      vehicle_mileage: ['', Validators.required],
      vehicle_model_id: ['', Validators.required],
      vehicle_model_year: ['', Validators.required],
      vehicle_trim: ['', Validators.maxLength(150)],
      vehicle_retail_price: ['', Validators.required],
      vehicle_registration_date: ['', Validators.required],
      vehicle_co2_emissions: ['', Validators.required],
      vehicle_status: ['', Validators.required],
      vehicle_units: ['', Validators.required],
      license_plate: ['', Validators.required],
      vin: ['', Validators.required],
      vehicle_upholstery: ['', Validators.required],
    });
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes['ladata']) {
        this.brands = this.ladata.brands;
        this.dealershipData = this.ladata.dealershipData;
      }

      if (changes['orderData']) {
        if (this.orderData) {
          this.refrescarFormulario();
        }
      }
    }
  }


  refrescarFormulario() {
    this.updateFieldAccessibility();
    this.availableVins = this.orderData?.available_campaign_stock_vins || [];
    if (this.models.length === 0) {
      if (this.orderData.vehicle_brand_id) {
        this.onBrandChange(this.orderData.vehicle_brand_id);
      }
    }

    for (const key in this.orderData) {
      const control = this.vehicleForm.controls[key];
      const value = this.orderData[key];

      if (control) {
        switch (key) {
          case 'delivery_first_expected_date':
            control.setValue(value ? moment(value).format('DD/MM/YYYY') : '');
            break;
          default:
            control.setValue(value);
            break;
        }

      }
    }
    this.alertService.close();
  }

  async onBrandChange(value: any) {
    if (!value) return;
    var brand_reference: any = '';
    if (typeof value === 'string') {
      brand_reference = value;
    } else if (value && typeof value === 'object' && value.reference) {
      // ng-select pasa el objeto item directamente
      brand_reference = value.reference;
    } else if (value && value.target) {
      brand_reference = value.target.value;
    }

    if (!brand_reference) return;

    try {
      const data = await this.modelService.getDataByBrand(brand_reference).toPromise();
      this.models = data.data;
      if (brand_reference != this.orderData.vehicle_brand_id) {
        this.vehicleForm.get('vehicle_model_id')?.setValue('');
      }
    } catch (error) {
      console.error('There was an error!', error);
    }

    if (!this.orderData.vehicle_brand_id) {
      this.emitChangeBrand.emit(brand_reference);
    }

  }

  updateFieldAccessibility() {

    var rules = this.orderData?.rules;
    // Deshabilitar todos los campos por defecto
    for (const field in this.vehicleForm.controls) {
      if (this.vehicleForm.controls.hasOwnProperty(field)) {
        this.vehicleForm.get(field)?.disable();
      }
    }

    // Habilitar solo los campos con valor 'w' en las reglas
    for (const field in rules) {
      if (rules.hasOwnProperty(field) && rules[field] === 'w') {
        this.vehicleForm.get(field)?.enable();
      }
    }

  }
  checkUpdateForm(): boolean {
    if (this.vehicleForm.dirty) {
      return true;
    } else {
      return false;
    }
  }
  copyToClipboard(value: string, event: Event): void {
    copyToClipboardUtil(value, event);
  }

  duplicate() {
    this.emitDuplicate.emit(true);
  }

  fillVehicleFormForHelper(option: any) {
    this.vehicleForm.get('vehicle_model_id')?.setValue(option['vehicle_model_id']);
    this.vehicleForm.get('vehicle')?.setValue(option['vehicle']);
    this.vehicleForm.get('vehicle_status')?.setValue(option['vehicle_status']);
    this.vehicleForm.get('vehicle_units')?.setValue(option['vehicle_units']);
    this.vehicleForm.get('vehicle_model_year')?.setValue(option['vehicle_model_year']);
    this.vehicleForm.get('colour')?.setValue(option['colour']);
    this.vehicleForm.get('vehicle_trim')?.setValue(option['vehicle_trim']);
  }

  openVinSelector(): void {
    this.showVinSelector = true;
  }

  onVinSelected(vin: CampaignStockVin): void {
    this.vehicleForm.get('vin')?.setValue(vin.vin);
    if (vin.license_plate) {
      this.vehicleForm.get('license_plate')?.setValue(vin.license_plate);
    }
    if (vin.dealership_id && !this.orderData?.dealership_id) {
      this.dealershipFromVin.emit(vin.dealership_id);
    }
    this.vehicleForm.markAsDirty();
    this.showVinSelector = false;
    this.showAlertVin = false;
  }

  closeVinSelector(): void {
    this.showVinSelector = false;
  }

  async onBlurVin(value: string) {
    try {
      const data = await this.orderService.checkVin(this.orderData.reference,value).toPromise();
      if (data.data) {
        this.showAlertVin = true;
        this.urlVin = data.data.url;
      }
    } catch (error) {
      console.error('There was an error!', error);
    }
  }

  async onBlurLicensePlate(value: string) {
    try {
      const data = await this.orderService.checkLicensePlate(this.orderData.reference,value).toPromise();
      if (data.data) {
        this.showAlertLicensePlate = true;
        this.urlLicensePlate = data.data.url;
      }
    } catch (error) {
      console.error('There was an error!', error);
    }
  }


}
